export const removeEmptyAriaOwns = (containerRef) => {
  if (!containerRef) return;
  const elements = containerRef.querySelectorAll('[aria-owns=""]');
  for (let i = 0; i < elements.length; i += 1) {
    elements[i].removeAttribute('aria-owns');
  }
};



// WEBPACK FOOTER //
// ./src/lib/a11yUtils.js